import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// 제목·안내 문구·확인 버튼으로 된 안내 팝업. 열리면 확인 버튼에 포커스를 준다.
export default function NoticeModal({ title, message, onConfirm }) {
    const confirmRef = useRef(null);
    useEffect(() => { confirmRef.current?.focus(); }, []);
    return <div className="auth-modal-backdrop">
        <div className="auth-modal" role="alertdialog" aria-modal="true" aria-labelledby="auth-modal-title" aria-describedby="auth-modal-desc">
            <h2 id="auth-modal-title">{title}</h2>
            <p id="auth-modal-desc">{message}</p>
            <button ref={confirmRef} type="button" className="auth-submit" onClick={onConfirm}>확인</button>
        </div>
    </div>;
}

NoticeModal.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
};
